module.exports = __webpack_public_path__ + "static/meyerhoffer-meadows-plat-map-c55b166975ce73449c4af83618d64f62.jpg";